import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';




const firebaseConfig = initializeApp({
  apiKey: "AIzaSyAJyLf68pDz2fBppwMHIFTvf8bmn5PvJOw",
  authDomain: "wood-identification-app.firebaseapp.com",
  databaseURL: "https://wood-identification-app-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "wood-identification-app",
  storageBucket: "wood-identification-app.appspot.com",
  messagingSenderId: "318988626747",
  appId: "1:318988626747:web:b424e1ec769879778b651e",
  measurementId: "G-QCMDKCHS1D"
})
// const app = initializeApp(firebaseConfig);
// // const analytics = getAnalytics(app);
// const db = getFirestore(app);
// const storage = getStorage(app);
export const auth = getAuth();
export default firebaseConfig;
